






import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Loader'
})
export default class App extends Vue {}
